module["exports"] = [
  "van",
  "van de",
  "van den",
  "van 't",
  "van het",
  "de",
  "den"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/nl/name/tussenvoegsel.js
// module id = 2139
// module chunks = 0